<template lang="pug">
  div
    span(v-html="tituloLista()")
    Inputfecha(v-for="l in ListFechas" :data="l" :key="l.id" :enabledForList="enabledList" @updateNominaciones="updateNominaciones")
    span(v-html="totales()")
    br
    a.button(@click="salirLista" v-show="isVisible") Salir
</template>

<script>
  import Inputfecha from './InputFecha.vue'
  import { mapState } from "vuex"
  
  export default {
    name: 'ListInputsFecha',
    components: { Inputfecha },
    props: {
      ListFechas: {
        type: Array,
        default: []
      },
      grupo: {
        type: String,
        default: ''
      },
      enabledList: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        isVisible: false
      }
    },
    watch: {
      ListFechas() {
        if (this.ListFechas.length > 0) {
          this.isVisible = true
        } else {
          this.isVisible = false
        }
      }
    },
    methods: {
      saveNominaciones() {
        console.log('save all')
      },
      salirLista() {
        this.$emit('ocultarListaDiaria', 'c')
      },
      totales() {
        let texto = ''
        let sumaNom = 0
        this.ListFechas.forEach(nomD => {
          sumaNom = sumaNom + Number(nomD.nominacion)
        })
        texto = `<span>La suma de ${this.ListFechas.length} días es: <b>${Number(sumaNom.toFixed(2))}</b></span>`
        return texto
      },
      tituloLista() {
        let texto = `<p class="has-size-6">Días y nominaciones para ${this.grupo}.</p>`
        return texto
      },

      updateNominaciones(update) {
        
        this.$emit('updateNominaciones', update ? 'c' : '')
      }
    },
    computed: {
      ...mapState(["logueado", "userLogin"])
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/nominaciones/componentes/ListInputsFecha.vue